import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Error from '@material-ui/icons/Error';

import { translate } from 'services/i18nService';
import GiftsStore from 'stores/GiftsStore';
import Button from 'components/Button/Button';
import routeDefinitions from 'enum/routeDefinitions';

import styles from './SendFeedback.css';


const SendFeedback = ({ perfomerName }) => {
  const { giftSendSuccessful, sendGiftErrorCode } = GiftsStore;

  const errorMessage = () => {
    switch (sendGiftErrorCode) {
      case 'GIFT_NOT_VISIBLE':
      case 'CATEGORY_NOT_VISIBLE':
        return translate('v2profile.gift.no.longer.available');

      default:
        return sendGiftErrorCode;
    }
  };

  return (
    <div className={styles.SendSuccessful}>
      {giftSendSuccessful ? (
        <CheckCircleOutlineIcon classes={{ root: styles.successIcon }} />
      ) : (
        <Error classes={{ root: styles.errorIcon }} />
      )}
      <h5>{giftSendSuccessful ? translate('v2profile.my.shop.success') : errorMessage()}</h5>
      {giftSendSuccessful && (
        <div className={styles.paragraph}>{translate('v2profile.has.received.your.gift', { 0: perfomerName })}</div>
      )}
      <div className={styles.paragraph}>
        {giftSendSuccessful ? translate('v2profile.browse.for.gifts') : translate('v2profile.send.another.gift')}
      </div>
      <Button
        className={styles.sendNewGift}
        label={translate('v2profile.send.new.gift')}
        link={routeDefinitions.get(routeDefinitions.profileV2.gifts, { user: perfomerName })}
      />
    </div>
  );
};

SendFeedback.propTypes = { perfomerName: PropTypes.string.isRequired };

export default observer(SendFeedback);
